import type { ReactNode } from "react";

import { USER_BOOKMARKS_PANEL_SCROLL_ELEMENT_ID } from "./constants";
interface ListWrapperProps {
  children: ReactNode;
}

export const ListWrapper = ({ children }: ListWrapperProps) => (
  <div className="flex min-h-0 flex-1 flex-col pb-5">
    <div
      className="min-h-0 flex-1 overflow-y-auto px-0 pt-2 lg:px-3"
      id={USER_BOOKMARKS_PANEL_SCROLL_ELEMENT_ID}
    >
      {children}
    </div>
  </div>
);
